import history from 'utils/history';

import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';

/**
 *
 * UserDropDown
 *
 */
import {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Modal,
	ModalBody,
	ModalHeader,
	UncontrolledDropdown,
} from 'reactstrap';

import { createStructuredSelector } from 'reselect';

import Avatar from 'atoms/Avatar/index.tsx';
import DefaultAvatar from 'atoms/DefaultAvatar';
import ManageAccountStatusContainer from 'containers/ManageAccountStatus';
import Settings from 'components/Settings';
import UpdateEmail from 'components/UpdateEmail';
import UpdatePassword from 'components/UpdatePassword';
import UpdatePhone from 'components/UpdatePhone';
import { pingServer } from 'containers/App/actions';
import { makeSelectServerVersion } from 'containers/App/selectors';
import { updateSettings, fetchSettings, resetSaved } from 'containers/ReferrerSettings/actions';
import {
	makeSelectSaving,
	makeSelectSaved,
	makeSelectLoading,
	makeSelectNotifyEmail,
	makeSelectNotifySms,
} from 'containers/ReferrerSettings/selectors';
import { openModal } from 'reducers/Modal';
import { MODALS } from 'v2/modals/list';

import {
	listUsers,
	logout,
	toggleAccountStatus,
	toggleEmail,
	toggleNotifications,
	togglePassword,
	togglePhone,
	toggleSettings,
	updateEmail,
	updateName,
	updatePassword,
	updatePasswordOther,
	updatePhone,
	verifyPassword,
} from './actions';
import './index.css';
import makeSelectUserDropDown from './selectors';

/* eslint-disable react/prefer-stateless-function */
export class UserDropDown extends React.Component {
	state = {
		notifyEmail: true,
	};

	savedResetTimer = null;

	handleNotificationSave = () => {
		const { doSaveNotifications } = this.props;
		doSaveNotifications({ notifyEmail: this.state.notifyEmail });
	};

	closeNotifications = () => {
		const { doToggleNotifications, doToggleSettings, doResetSaved } = this.props;
		if (this.savedResetTimer) {
			clearTimeout(this.savedResetTimer);
			this.savedResetTimer = null;
		}
		doResetSaved();
		doToggleNotifications();
		doToggleSettings();
	};

	openNotifications = () => {
		const { doToggleNotifications, doFetchSettings } = this.props;
		doToggleNotifications();
		doFetchSettings();
	};

	componentDidUpdate(prevProps) {
		const { notifyEmail, notificationsSaved, doResetSaved } = this.props;
		if (prevProps.notifyEmail !== notifyEmail) {
			this.setState({ notifyEmail });
		}
		if (notificationsSaved && !prevProps.notificationsSaved) {
			if (this.savedResetTimer) {
				clearTimeout(this.savedResetTimer);
			}
			this.savedResetTimer = setTimeout(() => {
				doResetSaved();
				this.savedResetTimer = null;
			}, 3000);
		}
	}

	componentWillUnmount() {
		if (this.savedResetTimer) {
			clearTimeout(this.savedResetTimer);
		}
	}

	logout = () => {
		const { logoutFunc } = this.props;

		logoutFunc();
	};

	componentDidMount = () => {
		const { doPing, serverVersion } = this.props;

		if (!serverVersion) {
			doPing();
		}
	};

	openPaymentInfo = () => {
		const { dispatch } = this.props;
		dispatch(openModal({ name: MODALS.UPDATE_PAYMENT_INFO }));
	};

	render() {
		const {
			user,
			userDropDown,
			doToggleSettings,
			doToggleEmail,
			doTogglePassword,
			doTogglePhone,
			doToggleAccountStatus,
			doVerifyPassword,
			doUpdateName,
			doUpdateEmail,
			doUpdatePhone,
			doUpdatePassword,
			doUpdatePasswordOthers,
			doListUsers,
			src,
			serverVersion,
			isMobile,
			notificationsSaving,
			notificationsSaved,
			notificationsLoading,
		} = this.props;

		return (
			<div>
				<UncontrolledDropdown nav inNavbar>
					<DropdownToggle
						className="text-dark d-flex align-items-center"
						nav
						caret
					>
						<div className="d-flex justify-content-center ">
							{!isMobile && (
								<div className="d-flex align-self-center mr-2">{user.name}</div>
							)}
							{src ? (
								<Avatar
									src="http://keenthemes.com/preview/metronic/theme/assets/pages/media/profile/profile_user.jpg"
									style={{ margin: '0 0.25rem' }}
								/>
							) : (
								<DefaultAvatar name={user.name} />
							)}
						</div>
					</DropdownToggle>
					<DropdownMenu
						right
						className={`user-drop-down ${isMobile && 'mobile'}`}
						flip={false}
					>
						<DropdownItem>
							<div className="d-flex justify-content-start mr-4 col-12 p-0 mt-2">
								{src ? (
									<Avatar
										src="http://keenthemes.com/preview/metronic/theme/assets/pages/media/profile/profile_user.jpg"
										style={{ margin: '0 0.5rem' }}
									/>
								) : (
									<DefaultAvatar name={user.name} />
								)}
								<div className="mr-4 col-11">
									<h6 className="m-0">{user.name}</h6>
									<p
										className="text-muted m-0 w-100"
										style={{ textOverflow: 'ellipsis', overflowX: 'hidden' }}
									>
										{user.email}
									</p>
									<span className="badge badge-dark">
										{user.roleName && user.roleName.toUpperCase()}
									</span>
								</div>
							</div>
						</DropdownItem>
						<DropdownItem divider />
						{user.roleName === 'admin' && (
							<DropdownItem
								onClick={() => history.push('/admin/dashboard/console')}
							>
								Admin Console
							</DropdownItem>
						)}
						<DropdownItem onClick={doToggleSettings}>Settings</DropdownItem>
						{user.roleName === 'patient' && user.onboardingComplete && (
							<DropdownItem onClick={this.openPaymentInfo}>
								Manage Payment Information
							</DropdownItem>
						)}
						<DropdownItem onClick={this.logout}>Log Out</DropdownItem>
					</DropdownMenu>
				</UncontrolledDropdown>
				{userDropDown.showSettings && (
					<Settings
						user={user}
						toggle={doToggleSettings}
						toggleEmail={doToggleEmail}
						togglePassword={doTogglePassword}
						togglePhone={doTogglePhone}
						toggleNotifications={this.openNotifications}
						toggleAccountStatus={doToggleAccountStatus}
						updateName={doUpdateName}
						serverVersion={serverVersion}
					/>
				)}
				{userDropDown.showEmailUpdate && (
					<UpdateEmail
						toggle={doToggleEmail}
						toggleSettings={doToggleSettings}
						verifyPassword={doVerifyPassword}
						updateEmail={doUpdateEmail}
						user={user}
						errorMsg={userDropDown.passwordError}
						passwordVerified={userDropDown.passwordVerified}
					/>
				)}
				{userDropDown.showPhoneUpdate && (
					<UpdatePhone
						toggle={doTogglePhone}
						toggleSettings={doToggleSettings}
						verifyPassword={doVerifyPassword}
						updatePhone={doUpdatePhone}
						user={user}
						errorMsg={userDropDown.passwordError}
						passwordVerified={userDropDown.passwordVerified}
					/>
				)}
				{userDropDown.showPassUpdate && (
					<UpdatePassword
						toggle={doTogglePassword}
						toggleSettings={doToggleSettings}
						updatePass={doUpdatePassword}
						user={user}
						updatePassOthers={doUpdatePasswordOthers}
						listUsers={doListUsers}
						users={userDropDown.users}
						errorMsg={userDropDown.passwordError}
					/>
				)}
				{userDropDown.showAccountStatus && (
					<ManageAccountStatusContainer
						toggle={doToggleAccountStatus}
						toggleSettings={doToggleSettings}
					/>
				)}
				{userDropDown.showNotifications && (
					<Modal
						className="modal-dialog-centered"
						isOpen
						toggle={this.closeNotifications}
					>
						<ModalHeader toggle={this.closeNotifications} className="border-remove" />
						<ModalBody>
							<div className="container-fluid">
								<h3 className="m-0 heading-update-pass">Notification Settings</h3>
								{notificationsLoading ? (
									<div className="text-center mt-4 mb-3">Loading...</div>
								) : (
									<div>
										<div className="mt-4 mb-3">
											<div className="form-check">
												<input
													className="form-check-input"
													type="checkbox"
													checked={this.state.notifyEmail}
													onChange={(e) => this.setState({ notifyEmail: e.target.checked })}
													id="notifyEmailCheckbox"
												/>
												<label className="form-check-label" htmlFor="notifyEmailCheckbox">
													Email notifications
												</label>
											</div>
										</div>
										<div className="mt-4 mb-2">
											<button
												onClick={this.handleNotificationSave}
												type="button"
												className="btn btn-primary btn-lg btn-block btn-color text-uppercase font-13"
												disabled={notificationsSaving}
											>
												{notificationsSaving ? 'SAVING...' : 'SAVE'}
											</button>
										</div>
										{notificationsSaved && (
											<div className="text-success text-center font-13 mt-2">
												Settings saved.
											</div>
										)}
									</div>
								)}
							</div>
						</ModalBody>
					</Modal>
				)}
			</div>
		);
	}
}

UserDropDown.propTypes = {
	user: PropTypes.object,
	userDropDown: PropTypes.object,
	logoutFunc: PropTypes.func.isRequired,
	doToggleNotifications: PropTypes.func.isRequired,
	doToggleSettings: PropTypes.func.isRequired,
	doToggleEmail: PropTypes.func.isRequired,
	doTogglePhone: PropTypes.func.isRequired,
	doTogglePassword: PropTypes.func.isRequired,
	doToggleAccountStatus: PropTypes.func.isRequired,
	doVerifyPassword: PropTypes.func.isRequired,
	doUpdateName: PropTypes.func.isRequired,
	doUpdateEmail: PropTypes.func.isRequired,
	doUpdatePassword: PropTypes.func.isRequired,
	doUpdatePasswordOthers: PropTypes.func.isRequired,
	doListUsers: PropTypes.func.isRequired,
	src: PropTypes.string,
	notificationsLoading: PropTypes.bool,
	notifyEmail: PropTypes.bool,
	notifySms: PropTypes.bool,
	notificationsSaving: PropTypes.bool,
	notificationsSaved: PropTypes.bool,
	doFetchSettings: PropTypes.func,
	doSaveNotifications: PropTypes.func,
	doResetSaved: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
	userDropDown: makeSelectUserDropDown(),
	serverVersion: makeSelectServerVersion(),
	notificationsSaving: makeSelectSaving(),
	notificationsSaved: makeSelectSaved(),
	notificationsLoading: makeSelectLoading(),
	notifyEmail: makeSelectNotifyEmail(),
	notifySms: makeSelectNotifySms(),
});

function mapDispatchToProps(dispatch) {
	return {
		dispatch,
		logoutFunc: () => dispatch(logout()),
		doToggleSettings: () => dispatch(toggleSettings()),
		doToggleNotifications: () => dispatch(toggleNotifications()),
		doToggleEmail: () => dispatch(toggleEmail()),
		doTogglePassword: () => dispatch(togglePassword()),
		doTogglePhone: () => dispatch(togglePhone()),
		doVerifyPassword: (data) => dispatch(verifyPassword(data)),
		doUpdateName: (data) => dispatch(updateName(data)),
		doUpdateEmail: (data) => dispatch(updateEmail(data)),
		doUpdatePhone: (data) => dispatch(updatePhone(data)),
		doUpdatePassword: (data) => dispatch(updatePassword(data)),
		doUpdatePasswordOthers: (data) => dispatch(updatePasswordOther(data)),
		doListUsers: (data) => dispatch(listUsers(data)),
		doToggleAccountStatus: () => dispatch(toggleAccountStatus()),
		doPing: () => dispatch(pingServer()),
		doSaveNotifications: (data) => dispatch(updateSettings(data)),
		doFetchSettings: () => dispatch(fetchSettings()),
		doResetSaved: () => dispatch(resetSaved()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDropDown);
